/*
 * Pashion: Flex Bundle builder (sections/bundle-builder.liquid).
 *
 * Ported from the Focal theme (pashionfootweardev). The section renders one card per slot
 * ("upper", "heel1".."heel4") and one modal per slot. Each modal controller emits a selection
 * back to <bundle-builder>, which updates the card and shows Add to cart once every slot is
 * filled. The cart line is the bundle product's own variant (the Flex Bundles parent) with the
 * chosen component variants in `_components`.
 */
!function () {
  'use strict';

  if (customElements.get('bundle-builder')) return;

  var productCache = {};

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      productCache[handle] = fetch(root + 'products/' + handle + '.js').then(function (res) {
        if (!res.ok) throw new Error('Product fetch failed: ' + handle);
        return res.json();
      });
    }
    return productCache[handle];
  }

  function normalizeHeight(h) {
    if (!h) return '3';
    var match = String(h).match(/[\d.]+/);
    return match ? match[0] : h;
  }

  function escapeAttr(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  /* Option position/key/values for a named option on a /products/{handle}.js payload */
  function getOptionValues(product, optionName) {
    for (var i = 0; i < product.options.length; i++) {
      var name = typeof product.options[i] === 'string' ? product.options[i] : product.options[i].name;
      if (name.toLowerCase() === optionName.toLowerCase()) {
        var key = 'option' + (i + 1);
        var seen = {};
        var values = [];
        product.variants.forEach(function (v) {
          if (!seen[v[key]]) {
            seen[v[key]] = true;
            values.push(v[key]);
          }
        });
        return { key: key, values: values };
      }
    }
    return null;
  }

  function makeButton(className, text) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = className;
    if (text != null) btn.textContent = text;
    return btn;
  }

  function setActive(container, selector, activeBtn) {
    container.querySelectorAll(selector).forEach(function (b) {
      b.classList.toggle('is-active', b === activeBtn);
    });
  }

  function clearChildren(el) {
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  /* =========================================================================
     Upper modal: Style → Color (when a style has >1 product) → Size
     ========================================================================= */
  function UpperModal(modal, onSelect) {
    this.modal = modal;
    this.onSelect = onSelect;
    this.options = JSON.parse(modal.querySelector('[data-modal-data]').textContent);
    this.styleIndex = 0;
    this.product = null;
    this.variantId = null;

    this.imageEl = modal.querySelector('[data-modal-image]');
    this.mobileImageEl = modal.querySelector('[data-modal-image-mobile]');
    this.styleLabel = modal.querySelector('[data-selected-style]');
    this.colorLabel = modal.querySelector('[data-selected-color]');
    this.colorLabelRow = modal.querySelector('[data-color-label-row]');
    this.colorsEl = modal.querySelector('[data-colors]');
    this.sizeLabel = modal.querySelector('[data-selected-size]');
    this.sizesEl = modal.querySelector('[data-sizes]');
    this.addBtn = modal.querySelector('[data-modal-add]');
    this.styleBtns = modal.querySelectorAll('.bundle-modal__style-btn');

    var self = this;
    this.styleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.selectStyle(parseInt(btn.dataset.styleIndex, 10));
      });
    });
    this.addBtn.addEventListener('click', this.add.bind(this));

    if (this.options.length && this.options[0].products.length) this.selectStyle(0);
  }

  UpperModal.prototype.onOpen = function () {};

  UpperModal.prototype.updateImage = function (product) {
    if (!product || !product.featured_image) {
      this.imageEl.hidden = true;
      this.mobileImageEl.hidden = true;
      return;
    }
    this.imageEl.src = product.featured_image;
    this.imageEl.alt = product.product_title || '';
    this.imageEl.hidden = false;
    this.mobileImageEl.src = product.card_image || product.featured_image;
    this.mobileImageEl.alt = product.product_title || '';
    this.mobileImageEl.hidden = false;
  };

  UpperModal.prototype.clearColors = function () {
    this.product = null;
    this.colorLabel.textContent = '—';
    clearChildren(this.colorsEl);
    this.colorLabelRow.hidden = true;
  };

  UpperModal.prototype.clearSizes = function () {
    this.variantId = null;
    this.sizeLabel.textContent = '—';
    clearChildren(this.sizesEl);
    this.addBtn.disabled = true;
  };

  UpperModal.prototype.renderSizes = function (product) {
    var self = this;
    this.clearSizes();

    product.variants.forEach(function (variant) {
      var parts = variant.title.split(' / ');
      var sizeText = parts[parts.length - 1];
      var btn = makeButton('bundle-modal__size-btn', sizeText);

      if (!variant.available) {
        btn.disabled = true;
        btn.classList.add('is-unavailable');
      }

      btn.addEventListener('click', function () {
        setActive(self.sizesEl, '.bundle-modal__size-btn', btn);
        self.variantId = variant.id;
        self.sizeLabel.textContent = sizeText;
        self.addBtn.disabled = false;
      });

      self.sizesEl.appendChild(btn);
    });
  };

  UpperModal.prototype.renderColors = function (option) {
    var self = this;
    this.clearColors();
    this.clearSizes();
    this.colorLabelRow.hidden = false;

    option.products.forEach(function (product) {
      var btn = makeButton('bundle-modal__color-btn');
      btn.title = product.color_label;
      btn.setAttribute('aria-label', product.color_label);
      if (product.swatch_image) btn.style.backgroundImage = 'url(' + product.swatch_image + ')';

      btn.addEventListener('click', function () {
        setActive(self.colorsEl, '.bundle-modal__color-btn', btn);
        self.product = product;
        self.colorLabel.textContent = product.color_label;
        self.updateImage(product);
        self.renderSizes(product);
      });

      self.colorsEl.appendChild(btn);
    });
  };

  UpperModal.prototype.selectStyle = function (index) {
    this.styleIndex = index;
    var option = this.options[index];

    this.styleBtns.forEach(function (btn) {
      btn.classList.toggle('is-active', parseInt(btn.dataset.styleIndex, 10) === index);
    });
    this.styleLabel.textContent = option.title;

    if (option.products.length === 1) {
      this.clearColors();
      this.product = option.products[0];
      this.updateImage(this.product);
      this.renderSizes(this.product);
    } else {
      this.updateImage(option.products[0]);
      this.renderColors(option);
    }
  };

  UpperModal.prototype.add = function () {
    if (!this.variantId || !this.product) return;
    var self = this;
    var price = 0;
    this.product.variants.forEach(function (v) {
      if (v.id == self.variantId) price = v.price / 100;
    });

    this.onSelect({
      variantId: this.variantId,
      productTitle: this.options[this.styleIndex].title,
      imageUrl: this.product.card_image || this.product.featured_image,
      upperImages: this.product.upper_images || {},
      color: this.product.color_label || '',
      size: this.sizeLabel.textContent,
      price: price
    });
  };

  /* =========================================================================
     Heel modal: Heel type → Color → Height → Size
     Colors/heights are aggregated across every product in the chosen type (e.g. separate
     3" and 4" heel products), preferring whichever product has stock.
     ========================================================================= */
  function HeelModal(modal, onSelect) {
    this.modal = modal;
    this.onSelect = onSelect;
    this.index = parseInt(modal.dataset.heelIndex, 10);
    this.useFeaturedImages = modal.hasAttribute('data-heels-only');
    this.options = JSON.parse(modal.querySelector('[data-modal-data]').textContent);

    this.typeIndex = 0;
    this.productIndex = null;
    this.color = null;
    this.height = null;
    this.variantId = null;
    this.currentOption = null;
    this.fetched = null;
    this.upperImages = null;
    this.initialized = false;

    this.imageEl = modal.querySelector('[data-modal-image]');
    this.overlayEl = modal.querySelector('[data-upper-overlay]');
    this.typeLabel = modal.querySelector('[data-selected-type]');
    this.colorLabel = modal.querySelector('[data-selected-color]');
    this.heightLabel = modal.querySelector('[data-selected-height]');
    this.sizeLabel = modal.querySelector('[data-selected-size]');
    this.colorsEl = modal.querySelector('[data-colors]');
    this.heightsEl = modal.querySelector('[data-heights]');
    this.sizesEl = modal.querySelector('[data-sizes]');
    this.addBtn = modal.querySelector('[data-modal-add]');
    this.loadingEl = modal.querySelector('[data-loading]');
    this.styleBtns = modal.querySelectorAll('.bundle-modal__style-btn');

    var self = this;
    this.styleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.selectType(parseInt(btn.dataset.styleIndex, 10));
      });
    });
    this.addBtn.addEventListener('click', this.add.bind(this));

    if (this.options.length && this.options[0].products.length) {
      var first = this.options[0].products[0];
      this.updateImage(this.useFeaturedImages ? first.featured_image : (first.card_image || first.featured_image), this.options[0].title);
    }
  }

  /* Product data is fetched lazily on first open */
  HeelModal.prototype.onOpen = function () {
    if (this.initialized || !this.options.length || !this.options[0].products.length) return;
    this.initialized = true;
    this.selectType(0);
  };

  HeelModal.prototype.setUpperImages = function (upperImages) {
    this.upperImages = upperImages || null;
    this.updateUpperOverlay();
  };

  HeelModal.prototype.updateUpperOverlay = function () {
    if (!this.overlayEl) return;
    var src = this.upperImages ? (this.upperImages[normalizeHeight(this.height)] || this.upperImages['3']) : null;
    if (src) this.overlayEl.src = src;
    this.overlayEl.hidden = !src;
  };

  HeelModal.prototype.updateImage = function (src, alt) {
    if (!src) {
      this.imageEl.hidden = true;
      return;
    }
    this.imageEl.src = src;
    this.imageEl.alt = alt || '';
    this.imageEl.hidden = false;
  };

  HeelModal.prototype.getStub = function () {
    if (this.productIndex === null) return null;
    return this.options[this.typeIndex].products[this.productIndex];
  };

  /* Customizer heel render (height-aware) normally; in heels-only mode the variant/product image */
  HeelModal.prototype.getImageForColor = function (stub, product, color, height) {
    if (!color) return null;
    var colorOpt = getOptionValues(product, 'Color');

    if (!this.useFeaturedImages) {
      if (normalizeHeight(height) === '4' && stub.card_image_4) return stub.card_image_4;
      if (stub.card_image) return stub.card_image;
    }

    if (colorOpt) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (v[colorOpt.key] !== color) continue;
        if (stub.variants[i] && stub.variants[i].featured_image) return stub.variants[i].featured_image;
        if (v.featured_image) return v.featured_image.src || v.featured_image;
      }
    }

    /* Fall back to matching the color name in image URLs */
    if (product.images) {
      var needle = color.toLowerCase().replace(/\s+/g, '');
      for (var j = 0; j < product.images.length; j++) {
        var src = typeof product.images[j] === 'string' ? product.images[j] : product.images[j].src;
        if (src && src.toLowerCase().replace(/\s+/g, '').indexOf(needle) !== -1) return src;
      }
    }
    return null;
  };

  HeelModal.prototype.clearFrom = function (level) {
    if (level <= 1) {
      this.color = null;
      this.productIndex = null;
      this.colorLabel.textContent = '—';
      clearChildren(this.colorsEl);
    }
    if (level <= 2) {
      this.height = null;
      this.heightLabel.textContent = '—';
      clearChildren(this.heightsEl);
    }
    if (level <= 3) {
      this.variantId = null;
      this.sizeLabel.textContent = '—';
      clearChildren(this.sizesEl);
      this.addBtn.disabled = true;
    }
  };

  HeelModal.prototype.selectType = function (index) {
    var self = this;
    this.typeIndex = index;
    var option = this.options[index];

    this.styleBtns.forEach(function (btn) {
      btn.classList.toggle('is-active', parseInt(btn.dataset.styleIndex, 10) === index);
    });
    this.typeLabel.textContent = option.title;
    this.clearFrom(1);
    this.updateUpperOverlay();

    var first = option.products[0];
    var typeImg = this.useFeaturedImages
      ? first.featured_image
      : ((normalizeHeight(this.height) === '4' && first.card_image_4) ? first.card_image_4 : (first.card_image || first.featured_image));
    this.updateImage(typeImg, option.title);
    this.loadingEl.classList.add('is-visible');

    Promise.all(option.products.map(function (p) { return fetchProduct(p.handle); }))
      .then(function (fetched) {
        /* Ignore a stale response if the shopper switched type mid-fetch */
        if (self.typeIndex !== index) return;
        self.loadingEl.classList.remove('is-visible');
        self.currentOption = option;
        self.fetched = fetched;
        self.renderColors();
      })
      .catch(function (err) {
        self.loadingEl.classList.remove('is-visible');
        console.error('[bundle-builder]', err);
      });
  };

  HeelModal.prototype.renderColors = function () {
    var self = this;
    var option = this.currentOption;
    this.clearFrom(1);

    var entries = [];
    var seen = {};

    option.products.forEach(function (stub, prodIndex) {
      var fetched = self.fetched[prodIndex];
      var colorOpt = getOptionValues(fetched, 'Color');
      if (!colorOpt) return;

      colorOpt.values.forEach(function (color) {
        var hasAvailable = fetched.variants.some(function (v) {
          return v[colorOpt.key] === color && v.available;
        });
        var entry = seen[color];
        if (!entry) {
          entry = seen[color] = {
            color: color,
            productIndex: prodIndex,
            swatch: stub.swatches && stub.swatches[color],
            available: hasAvailable
          };
          entries.push(entry);
        } else if (hasAvailable && !entry.available) {
          entry.available = true;
          entry.productIndex = prodIndex;
        }
      });
    });

    entries.forEach(function (entry) {
      var btn = makeButton('bundle-modal__color-btn');
      btn.title = entry.color;
      btn.setAttribute('aria-label', entry.color);
      if (entry.swatch) btn.style.background = entry.swatch + ' center / cover no-repeat';

      if (!entry.available) {
        btn.disabled = true;
        btn.classList.add('is-unavailable');
      }

      btn.addEventListener('click', function () {
        setActive(self.colorsEl, '.bundle-modal__color-btn', btn);
        self.color = entry.color;
        self.productIndex = entry.productIndex;
        self.colorLabel.textContent = entry.color;

        var stub = self.getStub();
        var product = self.fetched[entry.productIndex];
        var img = self.getImageForColor(stub, product, entry.color, self.height);
        self.updateImage(img || stub.featured_image, option.title + ' - ' + entry.color);

        self.renderHeights();
      });

      self.colorsEl.appendChild(btn);
    });
  };

  HeelModal.prototype.renderHeights = function () {
    var self = this;
    var previousHeight = this.height;
    this.clearFrom(2);

    var availability = {};
    var productForHeight = {};
    var ordered = [];

    this.currentOption.products.forEach(function (stub, prodIndex) {
      var fetched = self.fetched[prodIndex];
      var colorOpt = getOptionValues(fetched, 'Color');
      var heightOpt = getOptionValues(fetched, 'Heel Height');
      if (!heightOpt) return;

      heightOpt.values.forEach(function (h) {
        if (ordered.indexOf(h) === -1) ordered.push(h);
      });
      if (!colorOpt) return;

      fetched.variants.forEach(function (v) {
        if (v[colorOpt.key] !== self.color) return;
        var h = v[heightOpt.key];
        if (!(h in availability)) {
          availability[h] = false;
          productForHeight[h] = prodIndex;
        }
        if (v.available && !availability[h]) {
          availability[h] = true;
          productForHeight[h] = prodIndex;
        }
      });
    });

    var autoSelect = null;

    ordered.forEach(function (height) {
      if (!(height in availability)) return;

      var btn = makeButton('bundle-modal__size-btn', height);
      if (!availability[height]) {
        btn.disabled = true;
        btn.classList.add('is-unavailable');
      }

      btn.addEventListener('click', function () {
        setActive(self.heightsEl, '.bundle-modal__size-btn', btn);
        self.height = height;
        self.heightLabel.textContent = height;
        self.productIndex = productForHeight[height];
        self.updateUpperOverlay();

        var stub = self.getStub();
        var img = self.getImageForColor(stub, self.fetched[self.productIndex], self.color, height);
        if (img) self.updateImage(img, self.currentOption.title + ' - ' + self.color);

        self.renderSizes(self.fetched[self.productIndex]);
      });

      self.heightsEl.appendChild(btn);

      /* Keep the previously chosen height when switching color, if still available */
      if (previousHeight && height === previousHeight && availability[height]) autoSelect = btn;
    });

    if (autoSelect) autoSelect.click();
  };

  HeelModal.prototype.renderSizes = function (product) {
    var self = this;
    this.clearFrom(3);
    var colorOpt = getOptionValues(product, 'Color');
    var heightOpt = getOptionValues(product, 'Heel Height');
    var sizeOpt = getOptionValues(product, 'Size');
    if (!sizeOpt || !colorOpt || !heightOpt) return;

    var matching = product.variants.filter(function (v) {
      return v[colorOpt.key] === self.color && v[heightOpt.key] === self.height;
    });

    sizeOpt.values.forEach(function (size) {
      var variant = null;
      for (var i = 0; i < matching.length; i++) {
        if (matching[i][sizeOpt.key] === size) {
          variant = matching[i];
          break;
        }
      }
      if (!variant) return;

      var btn = makeButton('bundle-modal__size-btn', size);
      if (!variant.available) {
        btn.disabled = true;
        btn.classList.add('is-unavailable');
      }

      btn.addEventListener('click', function () {
        setActive(self.sizesEl, '.bundle-modal__size-btn', btn);
        self.variantId = variant.id;
        self.sizeLabel.textContent = size;
        self.addBtn.disabled = false;
      });

      self.sizesEl.appendChild(btn);
    });
  };

  HeelModal.prototype.add = function () {
    if (!this.variantId || this.productIndex === null) return;
    var self = this;
    var stub = this.getStub();
    var product = this.fetched[this.productIndex];
    var price = 0;
    var cardImage = stub.bundle_image || stub.featured_image;

    product.variants.forEach(function (v, i) {
      if (v.id != self.variantId) return;
      price = v.price / 100;
      if (!stub.bundle_image && stub.variants[i] && stub.variants[i].featured_image) {
        cardImage = stub.variants[i].featured_image;
      }
    });

    this.onSelect({
      index: this.index,
      variantId: this.variantId,
      productTitle: this.options[this.typeIndex].title,
      color: this.color,
      height: this.height,
      size: this.sizeLabel.textContent,
      price: price,
      imageUrl: cardImage
    });
  };

  /* =========================================================================
     <bundle-builder>
     ========================================================================= */
  customElements.define(
    'bundle-builder',
    class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.a11y = window.theme && window.theme.a11y ? window.theme.a11y : null;
        this.slots = (this.dataset.slots || '').split(',').filter(Boolean);
        this.selections = {};
        this.slots.forEach(function (key) { self.selections[key] = null; });

        this.atcBtn = this.querySelector('[data-bundle-atc]');
        this.banner = this.querySelector('[data-bundle-banner]');
        this.errorEl = this.querySelector('[data-bundle-error]');
        this.openModal = null;
        this.lastTrigger = null;

        this.modals = {};
        this.querySelectorAll('[data-bundle-modal]').forEach(function (modal) {
          var key = modal.dataset.bundleModal;
          /* One modal's bad data shouldn't take down the other slots */
          try {
            self.modals[key] = key === 'upper'
              ? new UpperModal(modal, function (detail) { self.onSelect('upper', detail); })
              : new HeelModal(modal, function (detail) { self.onSelect(key, detail); });
          } catch (err) {
            console.error('[bundle-builder] Could not initialise the ' + key + ' modal:', err);
          }
        });

        this._onClick = function (e) {
          var trigger = e.target.closest('[data-open-modal]');
          if (trigger && self.contains(trigger)) {
            self.open(trigger.dataset.openModal, trigger);
            return;
          }
          if (e.target.closest('[data-modal-close]')) self.close();
        };
        this._onKeydown = function (e) {
          if (e.key === 'Escape' && self.openModal) self.close();
        };
        this._onAtc = this.addToCart.bind(this);

        this.addEventListener('click', this._onClick);
        document.addEventListener('keydown', this._onKeydown);
        if (this.atcBtn) this.atcBtn.addEventListener('click', this._onAtc);

        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        document.removeEventListener('keydown', this._onKeydown);
        if (this.atcBtn) this.atcBtn.removeEventListener('click', this._onAtc);
        if (this.openModal) this.close();
      }

      open(key, trigger) {
        var controller = this.modals[key];
        if (!controller) return;
        if (this.openModal) this.close();

        var modal = controller.modal;
        this.openModal = modal;
        this.lastTrigger = trigger || null;
        modal.hidden = false;
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
        if (this.a11y) this.a11y.trapFocus(modal.querySelector('.bundle-modal-wrap__content'));
        controller.onOpen();
      }

      close() {
        var modal = this.openModal;
        if (!modal) return;
        this.openModal = null;
        modal.classList.remove('is-open');
        setTimeout(function () {
          if (!modal.classList.contains('is-open')) modal.hidden = true;
        }, 300);
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
        if (this.a11y) this.a11y.removeTrapFocus();
        if (this.lastTrigger) this.lastTrigger.focus();
      }

      onSelect(key, detail) {
        this.selections[key] = detail;

        var cardImage = this.querySelector('[data-card-image="' + key + '"]');
        var cardLabel = this.querySelector('[data-card-label="' + key + '"]');
        var cardDetails = this.querySelector('[data-card-details="' + key + '"]');

        if (cardImage && detail.imageUrl) {
          var alt = detail.color ? detail.productTitle + ' - ' + detail.color : detail.productTitle;
          cardImage.classList.remove('bundle-builder__card-image--unselected');
          cardImage.innerHTML = '<img src="' + escapeAttr(detail.imageUrl) + '" alt="' + escapeAttr(alt) + '" loading="lazy">';
        }

        if (cardLabel) cardLabel.textContent = 'Edit selection';

        if (cardDetails) {
          var firstLine = detail.height ? detail.height + ' ' + detail.productTitle : detail.productTitle;
          if (detail.size) firstLine += ' | ' + detail.size;
          clearChildren(cardDetails);
          [firstLine, detail.color].forEach(function (text) {
            if (!text) return;
            var p = document.createElement('p');
            p.textContent = text;
            cardDetails.appendChild(p);
          });
        }

        /* Heel modals composite their render over the chosen upper */
        if (key === 'upper') {
          var self = this;
          Object.keys(this.modals).forEach(function (k) {
            if (k !== 'upper') self.modals[k].setUpperImages(detail.upperImages);
          });
        }

        this.close();
        this.update();
      }

      isComplete() {
        var self = this;
        return this.slots.length > 0 && this.slots.every(function (key) { return !!self.selections[key]; });
      }

      update() {
        var complete = this.isComplete();
        if (this.atcBtn) this.atcBtn.hidden = !complete;
        if (this.banner) this.banner.hidden = complete;
      }

      addToCart() {
        if (!this.isComplete() || this.atcBtn.disabled) return;
        var self = this;
        var selected = this.slots.map(function (key) { return self.selections[key]; });

        var discount = (parseFloat(this.dataset.discount) || 15) / 100;
        var pct = Math.round(discount * 100);
        var originalTotal = selected.reduce(function (sum, sel) { return sum + (sel.price || 0); }, 0);
        var savings = Math.round(originalTotal * discount * 100) / 100;

        var currency = (window.Shopify && window.Shopify.currency) || {};
        var activeCurrency = currency.active || 'USD';
        var currencyRate = parseFloat(currency.rate) || 1;

        function formatMoney(amount) {
          var value = (amount || 0).toFixed(2);
          return activeCurrency === 'USD' ? '$' + value : activeCurrency + ' ' + value;
        }

        /* Flex Bundles Component Sum mode: each component carries its discounted price */
        var components = selected.map(function (sel) {
          var orig = sel.price || 0;
          return {
            id: parseInt(sel.variantId, 10),
            quantity: 1,
            price: Math.round(orig * (1 - discount) * 100) / 100,
            attributes: {
              'Original Price': formatMoney(orig),
              'You Save': formatMoney(Math.round(orig * discount * 100) / 100) + ' (' + pct + '%)'
            }
          };
        });

        var properties = {
          _components: JSON.stringify(components),
          _currency: activeCurrency,
          _currency_rate: String(currencyRate)
        };

        /* Cart thumbnails (snippets/cart-line-items.liquid) */
        this.slots.forEach(function (key) {
          var sel = self.selections[key];
          if (key === 'upper') properties._upper_image = sel.imageUrl;
          else properties['_heel_' + key.replace('heel', '') + '_image'] = sel.imageUrl;
        });

        properties['Retail Price'] = formatMoney(originalTotal);
        properties['Savings'] = formatMoney(savings) + ' (' + pct + '%)';

        var items = [{
          id: parseInt(this.dataset.parentVariantId, 10),
          quantity: 1,
          properties: properties
        }];

        var cartUrl = window.theme && window.theme.routes && window.theme.routes.cart_add_url
          ? window.theme.routes.cart_add_url
          : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';

        this.atcBtn.disabled = true;
        this.atcBtn.classList.add('is-loading');
        if (this.errorEl) this.errorEl.hidden = true;

        fetch(cartUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) { return res.json(); })
          .then(function (response) {
            self.atcBtn.disabled = false;
            self.atcBtn.classList.remove('is-loading');

            if (response.status) {
              if (self.errorEl) {
                self.errorEl.textContent = response.description || response.message || 'Unable to add to cart';
                self.errorEl.hidden = false;
              }
              return;
            }

            var cartDrawer = document.querySelector('cart-drawer');
            if (window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer' && cartDrawer) {
              document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
              cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
            } else {
              window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
            }
          })
          .catch(function (err) {
            self.atcBtn.disabled = false;
            self.atcBtn.classList.remove('is-loading');
            console.error('[bundle-builder] Add to cart error:', err);
          });
      }
    }
  );
}();
